import React, {useState, useEffect, useRef} from 'react';
import { useSelector } from 'react-redux';
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';

import './styles/clubsMap.scss';

const iconOptionsDefault = {
  iconLayout: 'default#image',
  iconImageHref: require('../../static/images/icons/map-marker.png'),
  iconImageSize: [36, 36],
  iconImageOffset: [-18, -18]
};

const iconOptionsClosed = {
  iconImageHref: require('../../static/images/icons/map-marker-disabled.png')
};

const iconOptionsActive = {
  iconImageSize: [55, 55],
  iconImageOffset: [-27, -27]
};

const mapDataDesktop = {
  center: [47.264126, 39.681951],
  zoom: 12,
  behaviors: ["drag"],
};

const mapDataTablet = {
  center: [47.264126, 39.611951],
  zoom: 12,
  behaviors: ["drag"],
};

const mapDataMobile = {
  center: [47.260126, 39.711951],
  zoom: 11,
  behaviors: ["drag"],
};

let mapData = mapDataDesktop;

const ClubsMap = (props) => {
  const { clubs, id } = props;
  const [activeClubId, setActiveClubId] = useState(id);
  const pageBreakpoint = useSelector((state) => state.utils.pageBreakpoint);
  const [showClubsDropdown, setShowClubsDropdown] = useState(false)

  useEffect(() => {
    if (!activeClubId && clubs.length) {
      //   setActiveClubId(clubs[0].id);
    }
  }, [clubs]);

  const handleMarkerClick = (id) => {
    if (id === activeClubId) {
      setActiveClubId(-1);
    } else {
      setActiveClubId(id);
    }
  };

  const noClubSelected = <div className="clubsMap__noClubSelected"><p className="clubsMap__noClubSelected__head">4 клуба fitron</p><p className="clubsMap__noClubSelected__description">Комфортный и безопасный фитнес во всех районах города.</p></div>

  const buttonHandler = () => {
    document.getElementById("offers").scrollIntoView({
      behavior: "smooth"
    });
  };

  const getInfoWindow = () => {
    if (activeClubId && activeClubId > 0) {
      const activeClub = clubs.filter((club) => {
        return club.id == activeClubId;
      })[0];
      // console.log('activeClub', activeClub);
      if (activeClub) {
        return (
          <div className="clubsMap__infowindow-content">
            <div className="clubsMap__infowindow-text">
              <div className="clubsMap__infowindow-title">{activeClub.name}</div>
              <div className="clubsMap__infowindow-description">
                <p>{activeClub.address.street}</p>
                <p className="clubsMap__infowindow-phone">{activeClub.formatted_phone}</p>
              </div>
              {/*
              <div className="clubsMap__infowindow-club-status">
                <p><span>31 декабря</span> 07:00 - 17:00</p>
                <p><span>1 января</span> выходной</p>
                <p><span>2 - 8 января</span> 09:00 - 21:00</p>
              </div>
              */}
              {!activeClub.is_closed ? (
                <div className="clubsMap__infowindow-club-status">
                  {activeClub.text_schedules}
                </div>
              ) : (
                <div className="clubsMap__infowindow-club-status _warning">
                  Клуб временно закрыт
                </div>
              )}
              <div className="clubsMap__infowindow-price">
                {/*Ежемесячно от <b>{activeClub.id == 3 ? '2 850' : '2 270'}</b> ₽/ мес.*/}
              </div>
            </div>
            <button
              className="clubsMap__infowindow-button"
              onClick={() => buttonHandler()}
            >
              Купить онлайн
            </button>
          </div>
        );
      } else {
        return noClubSelected;
      }
    } else {
      return noClubSelected;
    }
  };

  const dropdownRef = useRef(null);

  // click outside block dropdown
  const handleClickOutside = (e, id, title) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target) && showClubsDropdown) {
      setShowClubsDropdown(false);
    }
  }

  document.addEventListener('click', handleClickOutside);

  if (pageBreakpoint === 'tablet') {
    mapData = mapDataTablet;
  }

  if (pageBreakpoint === 'mobile') {
    mapData = mapDataMobile;
  }

  return (
    <section className="clubsMap">
      <div className="clubsMap__content">
        <div className="clubsMap__map-wrap">
          <div className="clubsMap__map">
            <YMaps>
              <Map defaultState={mapData} width="100%" height="100%" options={{minZoom: pageBreakpoint === 'mobile' ? 11 : 12, restrictMapArea: true}}>
                {clubs.map((club, index) => {
                  const isActive = activeClubId == club.id;
                  const isClosed = club.is_closed;
                  const activeOptions = isActive ? iconOptionsActive : {};
                  const closedOptions = isClosed ? iconOptionsClosed : {};
                  const options = {
                      ...iconOptionsDefault,
                      ...activeOptions,
                      ...closedOptions
                  }
                  return (
                    <Placemark
                      geometry={[club.latitude, club.longitude]}
                      key={index}
                      options={options}
                      onClick={handleMarkerClick.bind(this, club.id)}
                    />
                  );
                })}
              </Map>
            </YMaps>
          </div>
          <div className="clubsMap__infowindow">
            <div ref={dropdownRef}
                 className={'clubsMap__selectClub ' + (showClubsDropdown ? '_open' : '')}
            >
              <div
                  className="clubsMap__selectClub__selected" onClick={() => setShowClubsDropdown(!showClubsDropdown)}
              >
                {activeClubId && activeClubId > 0 ?  clubs.filter((club) => {
                  return club.id == activeClubId;
                })[0].name : 'Выбрать клуб'}
              </div>
              <ul className="clubsMap__selectClub__dropdown">
                {clubs.map((club, index) => {
                  return (
                      <li key={club.id} onClick={() => {
                        setActiveClubId(club.id);
                        setShowClubsDropdown(false)
                      }}>{club.name}</li>
                  );
                })}
              </ul>
            </div>
            {getInfoWindow()}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClubsMap;
